import EventEmitter from "eventemitter3";
import DataManager from "../data/DataManager";
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import {
  getDatabase,
  Database,
  ref,
  onValue,
  DatabaseReference,
  DataSnapshot,
  push,
  set,
  query,
  orderByChild,
  limitToLast,
} from "firebase/database";
// import NCMB from 'ncmb'

/**
 * RankingManagerクラス
 */
class RankingManager extends EventEmitter {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //シングルトンインスタンス
  private static _instance: RankingManager;

  private _config: object;

  //リーダーズボード（参照）
  private _lbRef: DatabaseReference;

  //リーダーズボード（データ）
  private _lbData: any;

  //ログイン済みかどうかのフラグ
  private _isLogIn: boolean = false;

  // ---------------------------------------------------------------------------------------------------------
  // --	RankingManager
  // ---------------------------------------------------------------------------------------------------------
  /**
   * コンストラクタ
   */
  private constructor() {
    super();
  }

  /** インスタンスの取得 */
  public static get instance(): RankingManager {
    if (!this._instance) {
      this._instance = new RankingManager();
    }

    // 生成済みのインスタンスを返す
    return this._instance;
  }

  // ----------------------------------------------------------------------------------------------------------------
  // --	初期化
  // ----------------------------------------------------------------------------------------------------------------

  init() {
    console.log("RankingManager.init()");

    // ========== NBD ==========
    // const firebaseConfig = {
    //   apiKey: "AIzaSyDLMMhGwVk3DqkQY7mY-fDxv-JOXJke7cs",
    //   authDomain: "jet-panda.firebaseapp.com",
    //   projectId: "jet-panda",
    //   storageBucket: "jet-panda.appspot.com",
    //   messagingSenderId: "126603671061",
    //   appId: "1:126603671061:web:30d32e12711c561a78401c",
    // };

    // ========== COUGER ==========
    const firebaseConfig = {
      apiKey: "AIzaSyBC94aEwAdeMwgOKxfhK4y_Vvx7enKmkLk",
      authDomain: "jetpanda.firebaseapp.com",
      projectId: "jetpanda",
      storageBucket: "jetpanda.appspot.com",
      messagingSenderId: "805418307936",
      appId: "1:805418307936:web:6d7e556f08d338c31ece05",
      measurementId: "G-1X2915PRQN",
    };

    // Firebaseとデータベースの準備
    const app: FirebaseApp = initializeApp(firebaseConfig);
    const db: Database = getDatabase(app);
    console.log(db);

    //データの取得
    this._lbRef = ref(db, "leadersboard/");
    onValue(
      query(this._lbRef, orderByChild("score"), limitToLast(100)),
      (snapshot: DataSnapshot) => {
        this._lbData = snapshot.val();
        console.log("this._lbData:", this._lbData);
      }
    );

    //匿名認証
    this.login((result: boolean) => {
      if (result) {
        console.log("匿名ログイン成功");
      }
    });
  }

  // ----------------------------------------------------------------------------------------------------------------
  // --	スコア送信
  // ----------------------------------------------------------------------------------------------------------------

  sendScore(username: string, score: number) {
    console.log("sendScore:" + username + " ::: " + score);
    //名前のチェック
    if (username === null || username === "") {
      username = prompt("ユーザ名を指定してください");
    }

    //ログインして送信
    this.login((result: boolean) => {
      if (result) {
        const newPostRef = push(this._lbRef);
        set(newPostRef, { username, score })
          .then((results) => {
            console.log("SUCCESS:", results);
            this.emit("SUCCESS");
          })
          .catch((err) => {
            console.log("ERROR:", err);
            this.emit("ERROR", err);
          });
      } else {
        console.log("ERROR:", "ログイン失敗");
        this.emit("ERROR", "ログイン失敗");
      }
    });
  }

  // ----------------------------------------------------------------------------------------------------------------
  // --	ランキングデータ取得
  // ----------------------------------------------------------------------------------------------------------------

  getRanking(): any {
    return this._lbData;
  }

  // ----------------------------------------------------------------------------------------------------------------
  // --	ログイン
  // ----------------------------------------------------------------------------------------------------------------

  login(callback: Function): void {
    //ログイン済み
    if (this._isLogIn) {
      console.log("ログイン済み");
      callback(this._isLogIn);
    }
    //未ログイン
    else {
      console.log("未ログイン");
      const auth = getAuth();
      signInAnonymously(auth)
        .then(() => {
          this._isLogIn = true;
          callback(this._isLogIn);
        })
        .catch((error) => {
          callback(this._isLogIn);
        });
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default RankingManager;
